import {parseUrl} from "./parse-url.ts";

/**
 * Turns a URL into an absolute URL.
 *
 * @param {string} url The URL to turn into an absolute URL.
 */
export const toAbsoluteUrl = (url: string): string => parseUrl(url).href;
